function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Logs",
  d: "M2.03,18.729A2.041,2.041,0,0,1,0,16.681V2.048A2.041,2.041,0,0,1,2.03,0h9.589A.542.542,0,0,1,12,.157l3.793,3.758a.552.552,0,0,1,.163.391V16.681a2.041,2.041,0,0,1-2.03,2.048ZM1.088,2.048V16.681a.946.946,0,0,0,.941.95h11.9a.946.946,0,0,0,.941-.95V4.856H12.335a1.268,1.268,0,0,1-1.261-1.272V1.1H2.03A.947.947,0,0,0,1.088,2.048ZM12.163,3.584a.174.174,0,0,0,.173.175h1.746l-1.919-1.9ZM4.086,14.193a.549.549,0,0,1,0-1.1h7.007a.549.549,0,0,1,0,1.1Zm0-2.2a.549.549,0,0,1,0-1.1h6.252a.549.549,0,0,1,0,1.1Zm0-2.194a.549.549,0,0,1,0-1.1h7.668a.549.549,0,0,1,0,1.1Z",
  fill: "#fff"
});

var SvgLogs = function SvgLogs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.955,
    height: 18.729,
    viewBox: "0 0 15.955 18.729",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logs.16fe44de.svg";
export { ForwardRef as ReactComponent };